import { useEffect, useState } from 'react'
import { useMobile } from 'src/hooks/useMobile'
import SmallArrowRight from 'src/components/Icons/SmallArrowRight'

import BenefitModal from './BenefitModal'

import '../clubeStyles.scss'

type QtsInfoProps = {
  title: string
  url: string
}

interface BenefitModalProps {
  icon: string
  title: string
  modalContent: {
    modalBanner?: string
    modalTitle?: string
    modalSubtitle?: string
    modalText: string
    howToUse: string
    modalButton: string
    modalButtonLink?: string
    modalButtonMode: string
    modalTiersImg?: string
    questions?: QtsInfoProps[]
  }
  size?: string
  justLoggedUser: boolean
}

interface BenefitsGridProps {
  bgSection: string
  benefits: BenefitModalProps[]
}

export default function BenefitsGrid({
  bgSection,
  benefits,
}: BenefitsGridProps) {
  const [selectedBenefit, setSelectedBenefit] = useState<
    null | typeof benefits[0]
  >(null)

  const { isMobile } = useMobile()

  const benefitsToRender = benefits?.filter(
    (benefit) => !benefit?.justLoggedUser
  )

  const handleSelect = (benefit: typeof benefits[0]) => {
    setSelectedBenefit(benefit)
  }

  const handleClose = () => {
    setSelectedBenefit(null)
  }

  useEffect(() => {
    if (selectedBenefit) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
  }, [selectedBenefit])

  return (
    <div
      className="font-inter w-full max-w-[1285px] mx-auto mb-[90px] px-[16px] md:mb-[160px] md:px-0 bg-right bg-no-repeat bgSectionBenefit"
      style={{
        backgroundImage: isMobile ? 'none' : `url(${bgSection})`,
        backgroundSize: 'auto 100%',
      }}
    >
      <h2 className="text-[20px] leading-[140%] mb-[24px] text-black font-medium md:text-[32px] md:pt-[30px] md:mb-[51px]">
        Confira outros benefícios
      </h2>

      <div className="w-full overflow-x-auto pb-[24px] md:overflow-visible gridScrollMob">
        <div
          className="grid grid-cols-2 grid-cols-6 gap-2 min-w-[640px] max-w-[1000px] md:min-w-0"
          style={{ width: 'max-content' }}
        >
          {benefitsToRender?.map((benefit) => (
            <button
              key={benefit.title}
              onClick={() => handleSelect(benefit)}
              className={`p-4 bg-white border border-black/10 flex flex-col gap-2 items-start text-left transition-colors ${
                benefit.size === 'large' ? 'col-span-2' : 'col-span-1'
              }`}
            >
              <img src={benefit.icon} alt={benefit.title} className="text-xl" />
              <span
                className="font-semibold min-h-[48px]"
                dangerouslySetInnerHTML={{ __html: benefit.title }}
              />
              <span className="ml-auto text-lg">
                <SmallArrowRight />
              </span>
            </button>
          ))}
        </div>
      </div>

      {selectedBenefit && (
        <BenefitModal
          modalContent={selectedBenefit.modalContent}
          onClose={handleClose}
        />
      )}
    </div>
  )
}
